require('./brokerCashChargeStep2.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_CASH_CHARGE_SIGNATURE_PATTERN_TYPE,
    BROKER_CASH_CHARGE_SIGNATURE_PATTERN_PARAM
} = require('constants/index');
const CLASS_NAME = 'broker-cash-charge-step2';

const BrokerCashChargeStep2 = props => {
    const { immBrokerCashCharge, actions, cancelButton, nextButton } = props;
    const product = immBrokerCashCharge.getIn(['contract', 'product']);
    const contractNumber = immBrokerCashCharge.getIn(['contract', 'number']);
    const signaturePatternParams = {
        chargeAccount: `${BROKER_CASH_CHARGE_SIGNATURE_PATTERN_PARAM}${product}${contractNumber}`
    };

    return (
        <WizardStep
            actions={actions}
            cancelButton={cancelButton}
            nextButton={nextButton}
            immFinalButton="cashCharge-emit"
            position="last"
        >
            <h4 className={`${CLASS_NAME}__header-title`}>
                <FormattedText value="cashCharge-operationConfirmation"/>
            </h4>
            <div className={`${CLASS_NAME}__info`}>
                <FormattedText value="cashCharge-verifyInformation"/>
            </div>
            <div className={`${CLASS_NAME}__signature-pattern`}>
                <SignaturePattern
                    operationType={BROKER_CASH_CHARGE_SIGNATURE_PATTERN_TYPE}
                    operationParams={signaturePatternParams}
                />
            </div>
        </WizardStep>
    );
};

BrokerCashChargeStep2.propTypes = {
    immBrokerCashCharge: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerCashChargeStep2.defaultProps = {
    cancelButton: true,
    nextButton: true
}

module.exports = BrokerCashChargeStep2;